import { getFontStyles, createFontStyle } from '../'

const ListItem = createFontStyle('ListItem', { type: 'Paragraph', tagName: 'li', name: '4' }, ({ inverseColor, theme, ordered }) => {
  const {
    spacingMultiplier,
    typography,
    custom: { link, paragraph }
  } = theme
  const { name, type, ...a } = link
  const styles = getFontStyles(typography, { type: 'Paragraph', name: paragraph.name })

  return {
    listStyleType: ordered ? 'decimal' : 'disc',
    fontSize: paragraph.fontSize || styles.fontSize,
    direction: 'ltr',
    color: inverseColor ? paragraph.inverseColor : paragraph.color,
    margin: `0 ${2 * spacingMultiplier}px ${3 * spacingMultiplier}px ${2 * spacingMultiplier}px`,
    '> a': a.default,
    '> a:hover': a.hover
  }
})

export default ListItem
